import ButtonWithIcon, {
    ButtonWithIconProps,
} from '@/components/common/ButtonWithIcon';
import { ArrowRight } from '@/components/common/icons';
import FinancialEntityWithMask from '@/components/financialEntities/FinancialEntityWithMask';
import usePlaid from '@/components/plaid/usePlaid';
import { ExternalFinancialEntity } from '@common/financialEntities';

const FinancialEntityRelinkButton = ({
    account,
    title,
    size,
    showArrow = true,
}: {
    account: ExternalFinancialEntity;
    size?: ButtonWithIconProps['size'];
    title?: string;
    showArrow?: boolean;
}) => {
    const { open } = usePlaid({
        financialEntity: {
            id: account.id,
            type: account.type,
            linkStatus: account.linkStatus,
        },
    });

    if (!account.isMine) return null;

    return (
        <ButtonWithIcon
            size={size || 'md'}
            onClick={(e) => {
                e.stopPropagation();
                open();
            }}
            onClickEvent="Reconnect Account Button Clicked"
            onClickEventParams={{
                account_id: account.id,
                institution_name: account.institution?.name,
            }}
            variant="link"
            fontWeight="normal"
            iconRight={showArrow ? <ArrowRight /> : undefined}
        >
            {title || (
                <>
                    Reconnect <FinancialEntityWithMask asString fe={account} />
                </>
            )}
        </ButtonWithIcon>
    );
};

export default FinancialEntityRelinkButton;
